import Vue from 'vue';
import Router from 'vue-router';
import JwtService from '@/common/jwt.service';
import AppLayout from '@/components/layouts/AppLayout';
import LandingLayout from '@/components/layouts/LandingLayout';
import ShareLayout from '@/components/layouts/ShareLayout';
import i18n from '../i18n';
import {APP_ENV} from "@/common/config"
const amplitude = require('amplitude-js');


Vue.use(Router)

export const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/components/views/landing/Login'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  {
    path: '/signup/:token',
    name: 'Signup',
    component: () => import('@/components/views/landing/Signup'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  {
    path: '/email-confirmation/:token',
    name: 'EmailConfirmation',
    component: () => import('@/components/views/landing/EmailConfirmation'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  {
    path: '/child-confirmation/:token',
    name: 'ChildConfirmation',
    component: () => import('@/components/views/landing/ChildConfirmation'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  {
    path: '/organization-invite/:token',
    name: 'OrganizationInvite',
    component: () => import('@/components/views/landing/OrganizationInvite'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  {
    path: '/forgotten-password',
    name: 'ForgottenPassword',
    component: () => import('@/components/views/landing/ForgottenPassword'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  {
    path: '/subscriptions/:token',
    name: 'Unsubscribe',
    component: () => import('@/components/views/landing/Unsubscribe'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  {
    path: '/subscriptions/:token',
    name: 'UnsubscribeWeekly',
    component: () => import('@/components/views/landing/UnsubscribeWeekly'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  {
    path: '/email-change/:token',
    name: 'EmailChange',
    component: () => import('@/components/views/landing/EmailChange'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: () => import('@/components/views/landing/ResetPassword'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  {
    path: '/dashboard/:param?',
    name: 'Dashboard',
    component: () => import('@/components/views/DashboardContainer'),
    meta: {
      requiresAuth: true,
      bcLinkText: "Dashboard",
      layout: AppLayout
    }
  },
  {
    path: '/leaderboard',
    name: 'Leaderboard',
    component: () => import('@/components/views/LeaderboardContainer'),
    meta: {
      requiresAuth: true,
      bcLinkText: "Leaderboard",
      layout: AppLayout
    }
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import('@/components/views/Shop'),
    meta: {
      requiresAuth: true,
      bcLinkText: "Shop",
      layout: AppLayout
    }
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: () => import('@/components/views/CalendarContainer'),
    meta: {
      requiresAuth: true,
      bcLinkText: "Calendar",
      layout: AppLayout
    },
  },

  {
    path: '/calendar/activity/:activityId',
    name: 'CalendarActivity',
    component: () => import('@/components/views/CalendarActivityContainer'),
    meta: {
      requiresAuth: true,
      bcDynamic: true,
      bcLinkText: activityInfo => {
        if (activityInfo.type === 'INDIVIDUAL') {
          return "CALENDAR_ACTIVITY.individual";
        }

        return 'CALENDAR_ACTIVITY.team';
      },
      bcGetter: 'activityInfo',
      parentRoutes: [{
        name: 'Calendar',
        displayText: 'Calendar'
      }],
      layout: AppLayout
    }
  },
  {
    path: '/session-history',
    name: 'SessionHistory',
    component: () => import('@/components/views/SessionHistoryContainer'),
    meta: {
      requiresAuth: true,
      bcLinkText: "Session History",
      layout: AppLayout
    },
  },
  {
    path: '/playbook/getting-started',
    name: 'GettingStarted',
    component: () => import('@/components/views/playbook/GettingStarted'),
    meta: {
      requiresAuth: true,
      bcLinkText: "Getting Started",
      parentRoutes: [{
        name: 'Playbook',
        displayText: 'Playbook'
      }],
      layout: AppLayout
    }
  },
  {
    path: '/playbook/reading-data',
    name: 'ReadingTheData',
    component: () => import('@/components/views/playbook/ReadingTheData'),
    meta: {
      requiresAuth: true,
      bcLinkText: "Reading Data",
      parentRoutes: [{
        name: 'Playbook',
        displayText: 'Playbook'
      }],
      layout: AppLayout
    }
  },
  {
    path: '/playbook/doing-more',
    name: 'DoingMoreWithData',
    component: () => import('@/components/views/playbook/DoingMoreWithData'),
    meta: {
      requiresAuth: true,
      bcLinkText: "Doing More",
      parentRoutes: [{
        name: 'Playbook',
        displayText: 'Playbook'
      }],
      layout: AppLayout
    }
  },
  {
    path: '/playbook/troubleshooting',
    name: 'Troubleshooting',
    component: () => import('@/components/views/playbook/Troubleshooting'),
    meta: {
      requiresAuth: true,
      bcLinkText: "Troubleshooting",
      parentRoutes: [{
        name: 'Playbook',
        displayText: 'Playbook'
      }],
      layout: AppLayout
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/components/views/Profile'),
    meta: {
      requiresAuth: true,
      bcLinkText: "Profile",
      layout: AppLayout
    }
  },
  {
    path: '/additional-email/:token',
    name: 'AdditionalEmail',
    component: () => import('@/components/views/landing/AdditionalEmailConfirm'),
    meta: {
      requiresAuth: false,
      layout: LandingLayout
    }
  },
  // {
  //   path: '/share-activity/:activityId',
  //   name: 'ShareActivity',
  //   props: true,
  //   component: () => import('@/components/views/share/ShareActivity'),
  //   meta: {
  //     requiresAuth: false,
  //     layout: ShareLayout,
  //     metaTags: [
  //       {
  //         property: 'og:image',
  //         content: 'https://pbs.twimg.com/profile_images/738440704171618304/7hravLVA_400x400.jpg'
  //       }
  //     ]
  //   }
  // },
  {
    path: '*',
    redirect: to => {
      if (to.path !== '/') {
        let searchedURL = to.path.replace("/", "")
        
        if(APP_ENV==="production"){
           amplitude.getInstance().logEvent(`pwa: search for non-existing page`, {page: searchedURL});
        }
        else{
           console.log(`pwa: search for non-existing page`, {page: searchedURL});
        }
      }
      return { path: 'dashboard' }
    }
  }
]


export const router = new Router({
  linkActiveClass: 'active',
  routes,
  mode: 'history'
})

export default router

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = !!JwtService.getToken();

  // // This goes through the matched routes from last to first, finding the closest route with a title.
  // // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  // const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // // Find the nearest route element with meta tags.
  // const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // // If a route with a title was found, set the document (page) title to that value.
  // if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // // Remove any stale meta tags from the document using the key attribute we set below.
  // Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // // Skip rendering meta tags if there are none. <<<<< IMPORTANT (CONSOLE THROWS ERROR - CANNOT READ PROPERY META) >>>>
  // if(!nearestWithMeta) {
  //   if (requiresAuth && !isAuthenticated) {
  //     next({
  //       path: '/login', 
  //       query: {
  //         redirectTo: to.fullPath
  //     }})
  //   } else if (!requiresAuth && isAuthenticated && to.name === 'Login') {

  //     next('/dashboard');
  //   } else {
  //     next();
  //   }
  // } 

  // // Turn the meta tag definitions into actual elements in the head.
  // nearestWithMeta.meta.metaTags.map(tagDef => {
  //   const tag = document.createElement('meta');

  //   Object.keys(tagDef).forEach(key => {
  //     tag.setAttribute(key, tagDef[key]);
  //   });

  //   // We use this to track which meta tags we create, so we don't interfere with other ones.
  //   tag.setAttribute('data-vue-router-controlled', '');

  //   return tag;
  // })
  // // Add the meta tags to the document head.
  // .forEach(tag => document.head.appendChild(tag));


  if (requiresAuth && !isAuthenticated) {
    next({
      path: '/login',
      query: {
        redirectTo: to.fullPath
      }
    })
  } else if (!requiresAuth && isAuthenticated && to.name === 'Login') {

    next('/dashboard');
  } else {
    next();
  }
})

router.afterEach((to, from) => {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
  if (!from.name) {
    let splitName = to.name.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase()
    if(APP_ENV==="production"){
       amplitude.getInstance().logEvent(`pwa: load ${splitName} page`);
    }
    else{
       console.log(`pwa: load ${splitName} page`);
    }
  }
})
